import React, { useState } from 'react';

// Define studio images array
const studioImages = [
  '/images/studio/1.jpg',
  '/images/studio/2.jpg',
  '/images/studio/3.jpg',
  '/images/studio/4.jpg',
  '/images/studio/5.jpg',
  '/images/studio/6.jpg'
];

function About() {
  const [selectedImage, setSelectedImage] = useState(null);

  // const handleImageClick = (image) => {
  //   setSelectedImage(image);
  // };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Introduction Card */}
      <div className="bg-white p-8 rounded-lg mb-8">
        {/* Top section with image and initial text */}
        <div className="grid grid-cols-1 md:grid-cols-[300px,1fr] gap-8">
          {/* Left side - Image column */}
          <div className="w-full md:w-[300px] max-w-[300px] mx-auto">
            <img 
              src="/images/studio/cm.jpg"
              alt="Artist portrait"
              className="rounded-full object-cover aspect-square w-full"
            />
          </div>
          
          {/* Right side - Text column */}
          <div className="flex flex-col gap-4">
            <div className="text-center md:text-left">
              <h2 className="text-xl font-bold">Hey there!</h2>
              <h2 className="text-xl font-bold">I'm Chanmi (Chahn-mee).</h2>
            </div>
            <p className="text-base">
              I'm a licensed hand-poked tattoo artist based in Chicago. I specialize in dotwork and love creating detailed pieces in a relaxed, welcoming studio environment.
            </p>
            <p className="text-base">
              My work is inspired by old relics, natural textures, organic forms, classical paintings, and really, anything that I find unique beauty in. I enjoy translating those inspirations into delicate, thoughtful hand-poked imagery.
            </p>
          </div>
        </div>

        {/* Below content - Full width paragraphs */}
        <div className="mt-8 space-y-4">
          <p className="text-base">
            Creating with my hands has always come naturally to me. I grew up as a manga kid, always drawing, and that eventually led me to fine art. I went on to study Curatorial Studies and Art Management in Korea, where I earned my Bachelor's degree. After working as an independent curator, I found myself wanting to engage with art in a more practical, grounded way. That curiosity led me to shift into tech, where I worked as an app designer.
          </p>

          <p className="text-base">
            I started tattooing around 2020 on the side from an extension of my curiosity about the different forms of art. I found hand poke tattooing to be a deeply personal and meditative experience—something that helped me reconnect with myself. It became much deeper and more meaningful, and now tattooing is my full-time practice. I continue to grow through it every day, and I always will.
          </p>

          <p className="text-base">
            All are welcome at Moolmit Tattoo. 
          </p>
          <p className="text-base">
            For inquiries or any questions, please feel free to contact me at: contact@moolmit.tattoo 
          </p>
          <p className="text-base">
            Thanks for taking the time to get to know my work.
          </p>
        </div>
      </div>

      {/* Hand Poked Tattoo Card */}
      <div className="bg-white p-8 rounded-lg mb-8">
        <h2 className="text-2xl font-bold mb-4">Hand Poked Tattoo</h2>
        <p className="text-base">
          A hand-poked tattoo is a machine-free method where the artist manually pokes a needle into the skin. It's also known as "stick and poke," "machineless tattoo," or "acoustic tattoo."
          <br /><br />
          While the process can be slower than machine tattooing, it's often less painful and tends to heal faster due to less trauma to the skin (it's also quieter!). This technique gives the tattoo a unique texture and hand-crafted quality.
        </p>
      </div>

      {/* Map Section */}
      {/* <div className="bg-white rounded-lg overflow-hidden mb-8">
        <iframe
          title="Studio Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2921.8560836148868!2d-78.90136718776591!3d42.918076099544336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d31356445dc621%3A0xc8800b69019a6d11!2sMoolmit%20Tattoo!5e0!3m2!1sen!2sus!4v1744918264397!5m2!1sen!2sus"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div> */}

      {/* Location Info Card */}
      {/* <div className="bg-white p-8 rounded-lg mb-8">
        <h2 className="text-2xl font-bold mb-4">Location</h2>
        <p className="text-base mb-4">
          My studio is located at 1255 Niagara Street, Suite E, Buffalo, New York.
          <br />
          Parking is available on the back side of the building or on the street.
        </p>
        <p className="text-base mb-2">Hours by appointment only</p>
        
        <p className="text-base">Contact: contact@moolmit.tattoo</p>
      </div> */}

      {/* Studio Images Grid */}
      {/* <div className="grid grid-cols-3 gap-4 mb-8">
        {studioImages.map((image, index) => (
          <div key={index} className="cursor-pointer">
            <img
              src={image}
              alt={`Studio view ${index + 1}`}
              className="w-full"
              loading="lazy"
              onClick={() => handleImageClick(image)}
            />
          </div>
        ))}
      </div> */}

      {/* Image Modal (disabled for now) */}

      {false && selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-3xl max-h-[90vh] w-full mx-4 flex flex-col items-center">
            <img
              src={selectedImage}
              alt="Enlarged studio view"
              className="max-h-[85vh] w-auto object-contain"
              loading="lazy"
              onClick={(e) => e.stopPropagation()}
            />
            {/* Navigation Buttons */}
            <button
              className="absolute left-4 top-1/2 -translate-y-1/2 text-white bg-black/50 rounded-full p-3 hover:bg-black/75 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                const currentIndex = studioImages.indexOf(selectedImage);
                const prevIndex = currentIndex === 0 ? studioImages.length - 1 : currentIndex - 1;
                setSelectedImage(studioImages[prevIndex]);
              }}
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-6 w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M15 19l-7-7 7-7" 
                />
              </svg>
            </button>
            <button
              className="absolute right-4 top-1/2 -translate-y-1/2 text-white bg-black/50 rounded-full p-3 hover:bg-black/75 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                const currentIndex = studioImages.indexOf(selectedImage);
                const nextIndex = currentIndex === studioImages.length - 1 ? 0 : currentIndex + 1;
                setSelectedImage(studioImages[nextIndex]);
              }}
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-6 w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 5l7 7-7 7" 
                />
              </svg>
            </button>
            {/* Close Button */}
            <button
              className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-2 hover:bg-black/75 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(null);
              }}
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-6 w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
            </button>
          </div>
        </div>
      )}
      
    </div>
  );
}

export default About;
